import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectDefault from '../common/form/selectDefault';
import SelectAlteracao from '../common/form/selectAlteracao';
import FormatUtils from '../common/formatUtils/FormatUtils';
import ButtonTable from '../common/table/buttonTable';
import Map from '../common/map/mapRota';
import imagemAdd from '../assets/images/icone_add_imagem.png';
import { setError, setSuccess } from '../common/toast/toast';
import pdfAdd from '../assets/images/icone_add_pdf.png';
import pdfAdicionado from '../assets/images/icone_pdf_adicionado.png';
import {
	setModoTela, initForm, salvar, imprimir, imprimirNovo, carregarEndereco, atualizarWhatsAppVenda
} from './pedidoActions';
import DateFormat from '../common/dateFormat/DateFormat';
import consts from '../consts';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import Td from '../common/table/td';
import TBody from '../common/table/tBody';
import endereco from '../cliente/endereco/endereco';

class PedidoForm extends Component {

	state = {

	}

    componentWillMount() {

		let initSeletorArquivo = () => {
			const fileSelectorArquivo = document.createElement('input');
			fileSelectorArquivo.setAttribute('type', 'file');
			fileSelectorArquivo.addEventListener("change", (data) => {

				let reader = new FileReader();
				let file = data && data.path && data.path[0] && data.path[0].files && data.path[0].files[0] ? data.path[0].files[0] : null;
				if (!file) {
					file = data && data.target && data.target.files && data.target.files[0] ? data.target.files[0] : null;
				}

				if (file) {

					if (!file.type.includes('image/png') && !file.type.includes('image/jpg') && !file.type.includes('image/jpeg')) {
						setError('Selecione apenas (.PNG, .JPG e .JPEG)');
						return;
					}

					reader.onloadend = () => {


						let lista = (this.props.formularioValues.arquivos || []).map(item => item);
						lista.push({
							arquivo_base64: reader.result
						});

						this.props.initForm({
							...this.props.formularioValues,
							arquivos: lista
						});

						initSeletorArquivo();

					}

					reader.readAsDataURL(file);

				}
			});

			this.fileSelectorArquivo = fileSelectorArquivo;
		};

		initSeletorArquivo();

    }

	componentDidMount() {
		//Se é do sertão seta a Unidade
		setTimeout(() => {
			if (!this.props.formularioValues.id && this.props.usuarioCarregado && [30, 31, 32].includes(this.props.usuarioCarregado.id_perfil) && this.props.usuarioCarregado.ids_gestao_unidade[0]) {

				//1 - OLEO DIESEL B S10 ADITIVA
				let politicaS10 = this.props.listaPoliticaPreco.filter(item => item.id_unidade == this.props.usuarioCarregado.ids_gestao_unidade[0] && item.id_produto == 1)[0];
				let distribuidoraS10 = politicaS10 ? this.props.listaDistribuidora.filter(item => item.id == politicaS10.id_distribuidora)[0] : null;

				//3 - OLEO DIESEL B S500 ADITIVADO
				let politicaS500 = this.props.listaPoliticaPreco.filter(item => item.id_unidade == this.props.usuarioCarregado.ids_gestao_unidade[0] && item.id_produto == 3)[0];
				let distribuidoraS500 = politicaS500 ? this.props.listaDistribuidora.filter(item => item.id == politicaS500.id_distribuidora)[0] : null;

				//6 - GASOLINA
				let politicaGasolina = this.props.listaPoliticaPreco.filter(item => item.id_unidade == this.props.usuarioCarregado.ids_gestao_unidade[0] && item.id_produto == 6)[0];
				let distribuidoraGasolina = politicaGasolina ? this.props.listaDistribuidora.filter(item => item.id == politicaGasolina.id_distribuidora)[0] : null;

				//7 - ETANOL
				let politicaEtanol = this.props.listaPoliticaPreco.filter(item => item.id_unidade == this.props.usuarioCarregado.ids_gestao_unidade[0] && item.id_produto == 7)[0];
				let distribuidoraEtanol = politicaEtanol ? this.props.listaDistribuidora.filter(item => item.id == politicaEtanol.id_distribuidora)[0] : null;

				let itens = (this.props.formularioValues.itens || []).filter(item => item.ativo).map((item, i) => {

					//1 - OLEO DIESEL B S10 ADITIVA / 3 - OLEO DIESEL B S500 ADITIVADO / 6 - GASOLINA / 7 - ETANOL

					let politicaSelecionada = this.props.listaPoliticaPreco.filter(politica =>
						politica.id_unidade == this.props.usuarioCarregado.ids_gestao_unidade[0]
						&& politica.id_produto == item.id_produto)[0];

					return {
						...item,
						preco_unitario_bruto: politicaSelecionada ? FormatUtils.formatarValorTela(politicaSelecionada.preco_bruto, 4) : null,
						preco_unitario_base: politicaSelecionada ? FormatUtils.formatarValorTela(parseFloat(politicaSelecionada.preco) - parseFloat(politicaSelecionada.preco_frete), 4) : null,
						// preco_unitario: politicaSelecionada ? FormatUtils.formatarValorTela(politicaSelecionada.preco, 4) : 0,
						preco_unitario_frete: politicaSelecionada ? FormatUtils.formatarValorTela(politicaSelecionada.preco_frete, 4) : null,
					};
				});

				this.props.initForm({
					...this.props.formularioValues,
					id_unidade: this.props.usuarioCarregado.ids_gestao_unidade[0],
					id_distribuidora_s10: distribuidoraS10 ? distribuidoraS10.id : null,
					id_distribuidora_s500: distribuidoraS500 ? distribuidoraS500.id : null,
					id_distribuidora_gasolina: distribuidoraGasolina ? distribuidoraGasolina.id : null,
					id_distribuidora_etanol: distribuidoraEtanol ? distribuidoraEtanol.id : null,
					custo_operacao: this.props.listaUnidade.filter(item => item.id == this.props.usuarioCarregado.ids_gestao_unidade[0])[0] ? this.props.listaUnidade.filter(item => item.id == this.props.usuarioCarregado.ids_gestao_unidade[0])[0].custo_operacao || 0 : 0,
					// custo_operacao_s10: distribuidoraS10 ? distribuidoraS10.custo_operacao || 0 : 0,
					// custo_operacao_s500: distribuidoraS500 ? distribuidoraS500.custo_operacao || 0 : 0
					itens: itens
				}, true);
			}
		}, 1000);
	}

	getCor(idProduto) {
		if (!idProduto) {
			return null;
		} else if (idProduto == 1) {
			return '#FFFDD0';
		} else if (idProduto == 3) {
			return '#f2c2b8';
		} else if (idProduto == 5) {
			return '#66c0ff';
		} else if (idProduto == 6) {
			return '#ccc878';
		} else if (idProduto == 7) {
			return '#e1eef7';
		} else {
			return '#36d184';
		}
	}

    render() {

		let readOnly = (this.props.formularioValues.id && 
				this.props.formularioValues.id_status != 1 && this.props.formularioValues.id_status != 2 
				&& this.props.formularioValues.id_status != 4) || this.props.excluir ? 'readOnly' : '';
		
		let administrador = this.props.usuarioCarregado ? this.props.usuarioCarregado.id_perfil == 2 : false;

		const usuarioLogistica = this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_logistica;		

		let valorTotalBaseGeral = 0;
		let valorTotalGeral = 0;
		let quantidadeGeral = 0;
		let lucroTotalGeral = 0;
		let valorFreteGeral = 0;
		let quantidadeS10 = 0;
		let quantidadeS500 = 0;
		let quantidadeGasolina = 0;
		let quantidadeEtanol = 0;
		let precoUnitarioS10 = 0;
		let precoUnitarioS500 = 0;
		let precoUnitarioGasolina = 0;
		let precoUnitarioEtanol = 0;
		let lucroBrutoGeral = 0;
		
		let veiculo = this.props.listaVeiculo.filter(item => item.id == this.props.formularioValues.id_veiculo)[0];

		let custoOperacaoGeral = parseFloat(this.props.formularioValues.custo_operacao || 0);

		(this.props.formularioValues.itens || []).filter(item => item.ativo).forEach((item, i) => {

			//1 - OLEO DIESEL B S10 ADITIVA / 3 - OLEO DIESEL B S500 ADITIVADO / 6 - GASOLINA / 7 - ETANOL
			if (item.id_produto == 1 || item.id_produto == 3 || item.id_produto == 6 || item.id_produto == 7) {
							
				valorTotalBaseGeral += parseFloat(FormatUtils.formatarValorBanco(item.preco_unitario_base, 4))
					* parseFloat(FormatUtils.formatarValorBanco(item.quantidade, 2));
				valorTotalGeral += parseFloat(FormatUtils.formatarValorBanco(item.valor_total, 2));
				quantidadeGeral += parseFloat(FormatUtils.formatarValorBanco(item.quantidade, 2));
				
				let precoUnitario = parseFloat(FormatUtils.formatarValorBanco(item.preco_unitario, 4));
				let precoUnitarioBase = parseFloat(FormatUtils.formatarValorBanco(item.preco_unitario_base, 4));
				
				let margemBruta = precoUnitario - precoUnitarioBase;
				lucroBrutoGeral += parseFloat(FormatUtils.formatarValorBanco(item.quantidade, 2)) * margemBruta;
			
				valorFreteGeral += parseFloat(FormatUtils.formatarValorBanco(item.preco_unitario_frete, 4)) * parseFloat(FormatUtils.formatarValorBanco(item.quantidade, 2));
				lucroTotalGeral += parseFloat((parseFloat(FormatUtils.formatarValorBanco(item.quantidade, 2)) * parseFloat((parseFloat(FormatUtils.formatarValorBanco(item.preco_unitario, 4)) - parseFloat(FormatUtils.formatarValorBanco(item.preco_unitario_base, 4))).toFixed(4))).toFixed(2));
				
			}

			//1 - OLEO DIESEL B S10 ADITIVA / 3 - OLEO DIESEL B S500 ADITIVADO / 6 - GASOLINA / 7 - ETANOL
			if (item.id_produto == 1) {
				quantidadeS10 += parseFloat(FormatUtils.formatarValorBanco(item.quantidade, 2));
			} else if (item.id_produto == 3) {
				quantidadeS500 += parseFloat(FormatUtils.formatarValorBanco(item.quantidade, 2));
			} else if (item.id_produto == 6) {
				quantidadeGasolina += parseFloat(FormatUtils.formatarValorBanco(item.quantidade, 2));
			} else if (item.id_produto == 7) {
				quantidadeEtanol += parseFloat(FormatUtils.formatarValorBanco(item.quantidade, 2));
			}

			//1 - OLEO DIESEL B S10 ADITIVA / 3 - OLEO DIESEL B S500 ADITIVADO / 6 - GASOLINA / 7 - ETANOL
			if (item.id_produto == 1) {
				precoUnitarioS10 = parseFloat(FormatUtils.formatarValorBanco(item.preco_unitario_base, 4))
					+ parseFloat(FormatUtils.formatarValorBanco(item.preco_unitario_frete, 4));
			} else if (item.id_produto == 3) {
				precoUnitarioS500 = parseFloat(FormatUtils.formatarValorBanco(item.preco_unitario_base, 4))
				+ parseFloat(FormatUtils.formatarValorBanco(item.preco_unitario_frete, 4));
			} else if (item.id_produto == 6) {
				precoUnitarioGasolina = parseFloat(FormatUtils.formatarValorBanco(item.preco_unitario_base, 4))
				+ parseFloat(FormatUtils.formatarValorBanco(item.preco_unitario_frete, 4));
			} else if (item.id_produto == 7) {
				precoUnitarioEtanol = parseFloat(FormatUtils.formatarValorBanco(item.preco_unitario_base, 4))
				+ parseFloat(FormatUtils.formatarValorBanco(item.preco_unitario_frete, 4));
			}
		});

		let margemMediaGeral = lucroBrutoGeral / quantidadeGeral;

		//Calcula o Custo de Operação Geral com base no custo do S10 e S500 com a quantidade de cada um
		// let custoOperacaoS10 = quantidadeGeral > 0 ? parseFloat(((parseFloat(this.props.formularioValues.custo_operacao_s10) * quantidadeS10) / quantidadeGeral).toFixed(4)) : 0;
		// let custoOperacaoS500 = quantidadeGeral > 0 ? parseFloat(((parseFloat(this.props.formularioValues.custo_operacao_s500) * quantidadeS500) / quantidadeGeral).toFixed(4)) : 0;
		
		// if (parseFloat(this.props.formularioValues.custo_operacao) != (custoOperacaoS10 + custoOperacaoS500)) {
		// 	this.props.initForm({
		// 		...this.props.formularioValues,
		// 		custo_operacao: custoOperacaoS10 + custoOperacaoS500
		// 	});
		// }

		//Calcula o custo do frete por litro
		let custoFreteGeral = quantidadeGeral ? parseFloat((valorFreteGeral / quantidadeGeral).toFixed(4)) : 0;

		const distanciaCalculo = parseFloat(FormatUtils.formatarValorBanco(this.props.formularioValues.distancia, 0)) < (veiculo ? veiculo.distancia_minima : 0) 
			? (veiculo ? veiculo.distancia_minima : 0)
			: parseFloat(FormatUtils.formatarValorBanco(this.props.formularioValues.distancia, 0));

		let custoEntregaGeral = parseFloat((quantidadeGeral > 0 ? (parseFloat(this.props.formularioValues.custo_km) * distanciaCalculo) / quantidadeGeral : 0).toFixed(4));
		
		let margemMinimaGeral = custoOperacaoGeral + custoFreteGeral + custoEntregaGeral;
		let margemLiquidaGeral = margemMediaGeral - custoOperacaoGeral - custoFreteGeral - custoEntregaGeral;

		let lucroLiquidoGeral = parseFloat((quantidadeGeral * margemLiquidaGeral).toFixed(2));

		//1 - OLEO DIESEL B S10 ADITIVA / 3 - OLEO DIESEL B S500 ADITIVADO / 6 - GASOLINA / 7 - ETANOL
		if (!precoUnitarioS10) {
			let politicaCadastradaS10 = this.props.listaPoliticaPreco.filter(politica => 
				politica.id_unidade == this.props.formularioValues.id_unidade
				&& politica.id_produto == 1)[0]
			
			precoUnitarioS10 = politicaCadastradaS10 ? politicaCadastradaS10.preco : 0;
		}

		if (!precoUnitarioS500) {
			let politicaCadastradaS500 = this.props.listaPoliticaPreco.filter(politica => 
				politica.id_unidade == this.props.formularioValues.id_unidade
				&& politica.id_produto == 3)[0]
			
			precoUnitarioS500 = politicaCadastradaS500 ? politicaCadastradaS500.preco : 0;
		}

		if (!precoUnitarioGasolina) {
			let politicaCadastradaGasolina = this.props.listaPoliticaPreco.filter(politica => 
				politica.id_unidade == this.props.formularioValues.id_unidade
				&& politica.id_produto == 6)[0]
			
			precoUnitarioGasolina = politicaCadastradaGasolina ? politicaCadastradaGasolina.preco : 0;
		}

		if (!precoUnitarioEtanol) {
			let politicaCadastradaEtanol = this.props.listaPoliticaPreco.filter(politica => 
				politica.id_unidade == this.props.formularioValues.id_unidade
				&& politica.id_produto == 7)[0]
			
			precoUnitarioEtanol = politicaCadastradaEtanol ? politicaCadastradaEtanol.preco : 0;
		}

		let corMargem = '';
		if (quantidadeS500 + quantidadeS10 > 0) {
			if (margemLiquidaGeral <= 0) {
				corMargem = '#f55656';
			} else if (margemLiquidaGeral * 1.02 <= margemMinimaGeral) {
				corMargem = '#ded649';
			} else {
				corMargem = '#6bbd4d';
			}
		}

		// 1 - Digitando
		// 2 - Aguardando Aprovação
		// 3 - Rejeitado
		// 4 - Aprovado
		// 5 - Logística Parcial
		// 6 - Logística Finalizada
		// 7 - Entrega

		let acessoLogistica = !this.props.visualizacao && (this.props.formularioValues.id_status == 4 || this.props.formularioValues.id_status == 5 ||
			this.props.formularioValues.id_status == 6 || this.props.formularioValues.id_status == 7 || this.props.formularioValues.id_status == 8);

		let itensMapa = (this.props.formularioValues.itens || []).filter(item => item.ativo).map(item => ({
			...item,
			endereco: this.props.listaEndereco.filter(endereco => endereco.id == item.id_endereco)[0]
		}));

		let unidadeSelecionada = this.props.listaUnidade.filter(item => item.id == this.props.formularioValues.id_unidade)[0];

		let compartimentos = (veiculo ? veiculo.compartimentos || [] : []).map((compartimento, i) => ({
			id: i+1,
			valor: `Compartimento ${i+1}`,
			capacidade: parseFloat(compartimento),
			tamanho: veiculo.capacidade ? `${parseInt((compartimento * 100) / parseInt(veiculo.capacidade))}%` : 100,
			ocupacao: 0
		}));

		let compartimentosOcupados = [];

		for (let i = 0; i < (this.props.formularioValues.itens || []).filter(item => item.ativo).length; i++) {
			const item = (this.props.formularioValues.itens || []).filter(item => item.ativo)[i];

			compartimentosOcupados = compartimentosOcupados.concat(item.compartimentos || []);
			
			let volume = parseFloat(FormatUtils.formatarValorBanco(item.quantidade, 2));

			compartimentos = compartimentos.map(compartimento => {
				
				let disponivel = compartimento.capacidade - compartimento.ocupacao;
					
				if (!disponivel || !volume 
					|| !(item.compartimentos || []).includes(compartimento.id)) {
					return compartimento;
				} else {

					let registro = {
						...compartimento,
						id_produto: item.id_produto,
						ocupacao: compartimento.ocupacao + (volume <= disponivel ? volume : disponivel)
					}

					if (volume <= disponivel) {
						volume = 0;
					} else {
						volume -= disponivel;
					}

					return registro;
				}
			});

		}

		let alertas = [];
		if ((this.props.formularioValues.itens || []).filter(item => item.ativo).length > 1) {
			const item = (this.props.formularioValues.itens || []).filter(item => item.ativo)[(this.props.formularioValues.itens || []).filter(item => item.ativo).length - 1];
			const endereco = this.props.listaEndereco.filter(endereco => endereco.id == item.id_endereco)[0];
			if (endereco && endereco.serra) {
				alertas.push('Cliente na serra não pode estar no último compartimento')
			}
		}

		(this.props.formularioValues.itens || []).filter(item => item.ativo).forEach((item, i) => {
			const veiculo = this.props.listaVeiculo.filter(item => item.id == this.props.formularioValues.id_veiculo)[0];
			const endereco = this.props.listaEndereco.filter(endereco => endereco.id == item.id_endereco)[0];

			if (veiculo && endereco && (veiculo.veiculo_tipos || []).length > 0 && endereco.veiculo_tipos.filter(tipo => tipo == veiculo.id_tipo).length == 0) {
				alertas.push(`Este veículo não pode entregar para ${endereco.valor}`)
			}

		});


		(this.props.formularioValues.itens || []).filter(item => item.ativo).forEach((item, i) => {
			const endereco = this.props.listaEndereco.filter(endereco => endereco.id == item.id_endereco)[0];

			if (endereco && endereco.alerta_entrega) {
				alertas.push(endereco.alerta_entrega);
			}

		});

		let codigoVendedor = this.props.usuarioCarregado ? this.props.usuarioCarregado.codigo : null;

		return (
			<ContentCard>

				{this.state.itemVendaPerdida ? this.modalVendaPerdidaItem() : null}
				{this.state.modalVendaPerdida ? this.modalVendaPerdida() : null}
				{this.modalImprimir()}
				{this.modalEnderecoInformacoes()}

				{!this.props.formularioValues.simulador &&
				<ContentCardHeader>
					<Row>
						{this.props.formularioValues.id_status == 1 &&
							<Grid cols='6 6 4 2'>
								<Button
									text='Enviar para Aprovação'
									type={'success'}
									icon={'fa fa-plus'}
									event={() => {
										this.props.salvar({
											...this.props.formularioValues,
											id_status: 2
										});
									}} />
							</Grid>
						}
						
						{this.props.formularioValues.id_status == 2 && 
							<Grid cols='6 6 4 2'>
								<Button
									text='Aprovar'
									type={'success'}
									icon={'fa fa-plus'}
									event={() => {
										this.props.salvar({
											...this.props.formularioValues,
											id_status: 4,
											id_usuario_aprovacao_rejeicao: this.props.sessao.id,
											datahora_aprovacao_rejeicao: DateFormat.getDataHoraAtual()
										});
									}} />
							</Grid>
						}
						{this.props.formularioValues.id_status == 2 && 
							<Grid cols='6 6 4 2'>
								<Button
									text='Rejeitar'
									type={'danger'}
									icon={'fa fa-plus'}
									event={() => {
										this.props.salvar({
											...this.props.formularioValues,
											id_status: 3,
											id_usuario_aprovacao_rejeicao: this.props.sessao.id,
											datahora_aprovacao_rejeicao: DateFormat.getDataHoraAtual()
										});
									}} />
							</Grid>
						}

						{(this.props.formularioValues.id && this.props.formularioValues.id_status == 1) && 
							<Grid cols='6 6 4 2'>
								<Button
									text='Venda Perdida'
									type={'danger'}
									icon={'fa fa-plus'}
									event={() => {
										this.props.initForm({
											...this.props.formularioValues,
											concorrente: '',
											preco_concorrente_s10: null,
											preco_concorrente_s500: null
										});
										this.setState({ ...this.state, modalVendaPerdida: true });
									}} />
							</Grid>
						}

						{(acessoLogistica || ((administrador || usuarioLogistica) && (this.props.formularioValues.id_status == 3 || this.props.formularioValues.id_status == 7))) &&
							<SelectDefault
								options={this.props.listaStatus}
								label='Status'
								cols='12 12 12 12'
								placeholder='Selecione o status'
								readOnly={null}
								value={this.props.formularioValues.id_status}
								onChange={data => {

									const value = data.target.value;

									if (value) {
										let registro = { 
											...this.props.formularioValues,
											id_status: value
										};
										//Digitando - Reabrir
										if (value == 1) {
											registro = {
												...registro,
												id_usuario_aprovacao_rejeicao: null,
												id_usuario_logistica: null,
												id_usuario_entrega: null,
												datahora_aprovacao_rejeicao: null,
												datahora_logistica: null,
												datahora_entrega: null
											}
										}
										//Aprovado
										if (value == 4) {
											registro = {
												...registro,
												id_usuario_logistica: null,
												id_usuario_entrega: null,
												datahora_logistica: null,
												datahora_entrega: null
											}
										}
										//Logística Parcial
										if (value == 5) {
											registro = {
												...registro,
												id_usuario_logistica: null,
												id_usuario_entrega: null,
												datahora_logistica: null,
												datahora_entrega: null
											}
										}
										//Logística Finalizada
										if (value == 6) {
											// if ((this.props.formularioValues.itens || []).filter(item => item.ativo).filter(item => {
											// 	console.log(item);
											// 	return !item.data_emissao_nfe || !item.numero_nfe;
											// }).length) {
											// 	this.props.initForm({
											// 		...this.props.formularioValues,
											// 		id_status: this.props.formularioValues.id_status
											// 	});
											// 	setError('Informe Date de Emissão e Número da NF-e nos itens');
											// 	return;
											// }
											registro = {
												...registro,
												id_usuario_logistica: this.props.sessao.id,
												id_usuario_entrega: null,
												datahora_logistica: DateFormat.getDataHoraAtual(),
												datahora_entrega: null
											}
										}
										//Entrega
										if (value == 7) {
											registro = {
												...registro,
												id_usuario_entrega: this.props.sessao.id,
												datahora_entrega: DateFormat.getDataHoraAtual()
											}
										}
										this.props.salvar(registro);
									}
							}} />
						}
					</Row>
				</ContentCardHeader>}

				{this.props.formularioValues.simulador &&
				<ContentCardHeader>
					<Row>
						<span class='badge badge-primary' 
							style={{
								fontSize: 18,
								marginLeft: 8,
								padding: 10
							}}>
							SIMULADOR
						</span>
						{this.props.formularioValues.id &&
						<Grid cols='6 6 4 2'>
							<Button
								text='Criar Pedido'
								type={'primary'}
								icon={'fa fa-plus'}
								title='Cria pedido a partir da simulação'
								event={() => {
									if (this.props.pedidosBloqueio) {
										window.alert('Você tem giros que devem ser tratados como venda perdida. Realize o envio para venda perdida para abrir novos giros.');
									} else {
										this.props.salvar({
											...this.props.formularioValues,
											id: null,
											simulador: false, 
											itens: (this.props.formularioValues.itens || []).filter(item => item.ativo).map(item => ({
												...item,
												id: null
											}))
										});
									}
								}} />
						</Grid>}
					</Row>
				</ContentCardHeader>}

				<Form event={this.props.handleSubmit}>
					{!this.props.modoLogistica ? (
						<ContentCardBody>
							{(this.props.formularioValues.id_status == 5 
								|| this.props.formularioValues.id_status == 6
								|| this.props.formularioValues.id_status == 7) && /*Logística Parcial, Logística Finalizada, Finalizado Base*/
							<Row>
								
								<Field
									name='retirado_base'
									component={LabelAndCheckbox}
									label='Retirado na Base' placeholder='Informe'
									cols='12 6 4 3'/>

								{/*!this.props.formularioValues.retirado_base &&
								<Field
									name='codigo_sm_entrega'
									component={LabelAndInputNumber}
									label='Código SM Ida' placeholder='Informe o Código SM Ida'
									cols='12 6 4 3'
									casas={0} />}
								
								{!this.props.formularioValues.retirado_base &&								
								<Field
									name='codigo_sm_retorno'
									component={LabelAndInputNumber}
									label='Código SM Volta' placeholder='Informe o Código SM Volta'
									cols='12 6 4 3'
									casas={0} />*/}

							</Row>}

							<Row>
								<Grid cols='12 6 6 6'>
									<Row>
										<Select
											name='id_unidade'
											options={this.props.listaUnidade}
											label='Unidade'
											cols='12 10 10 10'
											placeholder='Selecione o unidade'
											readOnly={readOnly}
											value={this.props.formularioValues.id_unidade}
											onChange={data => {
												//1 - OLEO DIESEL B S10 ADITIVA
												let politicaS10 = this.props.listaPoliticaPreco.filter(item => item.id_unidade == data && item.id_produto == 1)[0];
												let distribuidoraS10 = politicaS10 ? this.props.listaDistribuidora.filter(item => item.id == politicaS10.id_distribuidora)[0] : null;

												//3 - OLEO DIESEL B S500 ADITIVADO
												let politicaS500 = this.props.listaPoliticaPreco.filter(item => item.id_unidade == data && item.id_produto == 3)[0];
												let distribuidoraS500 = politicaS500 ? this.props.listaDistribuidora.filter(item => item.id == politicaS500.id_distribuidora)[0] : null;

												//6 - GASOLINA
												let politicaGasolina = this.props.listaPoliticaPreco.filter(item => item.id_unidade == data && item.id_produto == 6)[0];
												let distribuidoraGasolina = politicaGasolina ? this.props.listaDistribuidora.filter(item => item.id == politicaGasolina.id_distribuidora)[0] : null;

												//7 - ETANOL
												let politicaEtanol = this.props.listaPoliticaPreco.filter(item => item.id_unidade == data && item.id_produto == 7)[0];
												let distribuidoraEtanol = politicaEtanol ? this.props.listaDistribuidora.filter(item => item.id == politicaEtanol.id_distribuidora)[0] : null;

												let itens = (this.props.formularioValues.itens || []).filter(item => item.ativo).map((item, i) => {
								
													//1 - OLEO DIESEL B S10 ADITIVA / 3 - OLEO DIESEL B S500 ADITIVADO
													
													let politicaSelecionada = this.props.listaPoliticaPreco.filter(politica => 
														politica.id_unidade == data
														&& politica.id_produto == item.id_produto)[0];
														
													return {
														...item,
														preco_unitario_bruto: politicaSelecionada ? FormatUtils.formatarValorTela(politicaSelecionada.preco_bruto, 4) : null,
														preco_unitario_base: politicaSelecionada ? FormatUtils.formatarValorTela(parseFloat(politicaSelecionada.preco) - parseFloat(politicaSelecionada.preco_frete), 4) : null,
														// preco_unitario: politicaSelecionada ? FormatUtils.formatarValorTela(politicaSelecionada.preco, 4) : 0,
														preco_unitario_frete: politicaSelecionada ? FormatUtils.formatarValorTela(politicaSelecionada.preco_frete, 4) : null,
													};
												});

												this.props.initForm({
													...this.props.formularioValues,
													id_unidade: data,
													id_distribuidora_s10: distribuidoraS10 ? distribuidoraS10.id : null,
													id_distribuidora_s500: distribuidoraS500 ? distribuidoraS500.id : null,
													id_distribuidora_gasolina: distribuidoraGasolina ? distribuidoraGasolina.id : null,
													id_distribuidora_etanol: distribuidoraEtanol ? distribuidoraEtanol.id : null,
													custo_operacao: this.props.listaUnidade.filter(item => item.id == data)[0] ? this.props.listaUnidade.filter(item => item.id == data)[0].custo_operacao || 0 : 0,
													// custo_operacao_s10: distribuidoraS10 ? distribuidoraS10.custo_operacao || 0 : 0,
													// custo_operacao_s500: distribuidoraS500 ? distribuidoraS500.custo_operacao || 0 : 0
													itens: itens
												}, true);

											}} />

										{this.props.formularioValues.id ? (
											<Field
												name='giro'
												component={LabelAndInputNumber}
												label='Giro' placeholder='Informe o giro'
												cols='12 2 2 2'
												casas={0}
												readOnly={'readOnly'} />
										) : null}

										{[4, 5, 6, 7, 8].includes(this.props.formularioValues.id_status) &&
										<>
											<Field
												name='latitude_origem'
												component={LabelAndInput}
												label='Latitude Origem' placeholder='Informe'
												cols='12 3 3 3'
												readOnly={acessoLogistica ? null : 'readOnly'} />

											<Field
												name='longitude_origem'
												component={LabelAndInput}
												label='Longitude Origem' placeholder='Informe'
												cols='12 3 3 3'
												readOnly={acessoLogistica ? null : 'readOnly'} />
											
											<Field
												name='latitude_destino'
												component={LabelAndInput}
												label='Latitude Destino' placeholder='Informe'
												cols='12 3 3 3'
												readOnly={acessoLogistica ? null : 'readOnly'} />
											
											<Field
												name='longitude_destino'
												component={LabelAndInput}
												label='Longitude Destino' placeholder='Informe'
												cols='12 3 3 3'
												readOnly={acessoLogistica ? null : 'readOnly'} />
										</>}

										<Select
											name='id_veiculo'
											options={this.props.listaVeiculo}
											label='Veículo'
											cols='12 7 7 7'
											placeholder='Selecione o veículo'
											readOnly={readOnly}
											value={this.props.formularioValues.id_veiculo}
											onChange={data => {
												let veiculo = this.props.listaVeiculo.filter(item => item.id == data)[0];									
												this.props.initForm({
													...this.props.formularioValues,
													id_veiculo: data,
													custo_km: veiculo ? veiculo.preco_km || 0 : 0,
													itens: this.props.formularioValues.itens.map(itemAux => {
														return {
															...itemAux,
															compartimentos: []
														};
													})
												});
											}} />
									
										<LabelAndInput
											label='Custo Km' 
											placeholder=''
											cols='12 3 3 3'
											readOnly={'readOnly'}
											value={FormatUtils.formatarValorTela(this.props.formularioValues.custo_km, 4)}
											onChange={data => {										
															
											}} />
										
										<Field
											name='fob'
											label='FOB' 
											component={LabelAndCheckbox}
											placeholder=''
											cols='12 2 2 2'
											readOnly={'readOnly'} />
											
										{(veiculo && veiculo.documentacao_vencida) && (
											<Grid cols='12 12 12 12'>
												<div class="alert alert-danger alert-dismissible">
													<h6><i class="icon fas fa-ban"></i> Veículo possui problemas na documentação!</h6>
												</div>
											</Grid>
										)}

										<LabelAndInput
											label='Capacidade Veículo' 
											placeholder=''
											cols='12 12 4 4'
											readOnly={'readOnly'}
											value={FormatUtils.formatarValorTelaDecimal(veiculo ? veiculo.capacidade : 0, 2)}
											onChange={data => {										
															
											}} />
											
										<Field
											name='distancia'
											component={LabelAndInputNumber}
											label='Distância (Km)' placeholder='Informe a distância'
											cols='12 12 4 4'
											casas={0}
											readOnly={readOnly} />

										<LabelAndInput
											label='Quantidade p/ Completar' 
											placeholder=''
											cols='12 12 4 4'
											readOnly={'readOnly'}
											backgroundColor={parseFloat(veiculo ? veiculo.capacidade : 0) - quantidadeGeral < 0 ? '#f55656' : null}
											value={FormatUtils.formatarValorTelaDecimal(parseFloat(veiculo ? veiculo.capacidade : 0) - quantidadeGeral, 2)}
											onChange={data => {										
															
											}} /> 
											
										<Field
											name='rota_link'
											component={LabelAndInput}
											label='Link da Rota' placeholder='Informe o link'
											cols='8 8 8 8'
											readOnly={readOnly} />

										<Grid cols='4 4 4 4'>

											<Row style={{ paddingBottom: 16 }}>
												<Grid cols='12 12 12 12'>
													<label>Imagem da Rota</label>
												</Grid>
												{(this.props.formularioValues.arquivos || []).map(arquivo => (
													<div style={{ display: 'flex', flexDirection: 'column', marginLeft: 8 }}>
														<span class="btn btn-outline-primary fileinput-button dz-clickable">
															<img src={arquivo.arquivo_base64 ? imagemAdd : (arquivo.arquivo ? imagemAdd : imagemAdd)} style={{ height: 30 }} />
														</span>
														<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingRight: 2, marginTop: 4 }}>
															<button
																type='button'
																class='btn btn-flat btn-outline-primary'
																style={{ width: '48%' }}
																disabled={arquivo.arquivo_base64 ? true : false}
																onClick={() => {
																	window.open(`${consts.URL}/${arquivo.arquivo}`, '_blank');
																}}>
																<i class='fas fa-download'></i>
															</button>

															<button
																type='button'
																class='btn btn-flat btn-outline-danger'
																style={{ width: '48%' }}
																disabled={readOnly}
																onClick={() => {
																	this.props.initForm({
																		...this.props.formularioValues,
																		arquivos: this.props.formularioValues.arquivos.filter(item => item != arquivo)
																	});
																}}>
																<i class='fas fa-trash-alt'></i>
															</button>
														</div>
													</div>
												))}
												
													<span class="btn btn-outline-primary fileinput-button dz-clickable" 
														style={{ marginLeft: 8 }}
														onClick={() => this.fileSelectorArquivo.click()}>
														<img src={pdfAdd} style={{ height: 30 }} />
													</span>
												
											</Row>

										</Grid>

										{this.props.formularioValues.id_status == 4 || this.props.formularioValues.id_status == 5 || this.props.formularioValues.id_status == 6 || this.props.formularioValues.id_status == 7 ? (
											<Field
												name='id_motorista'
												component={Select}
												options={this.props.listaMotorista}
												label='Motorista'
												cols='12 12 12 12'
												placeholder='Selecione o motorista'
												readOnly={acessoLogistica ? null : readOnly} />	
										) : null}

										{(this.props.formularioValues.itens || []).filter(item => item.ativo).map((item, i) => {
								
											let cliente = this.props.listaCliente.filter(cliente => cliente.id == item.id_cliente)[0];
											let endereco = this.props.listaEndereco.filter(endereco => endereco.id == item.id_endereco)[0];

											if (endereco && cliente && endereco.croqui) {
												return (
													<LabelAndInput
														name='croqui'
														component={LabelAndInput}
														label={`Croqui ${cliente.valor}`} placeholder='Croqui'
														cols='12 12 12 12'
														readOnly={'readOnly'}
														value={endereco.croqui}
														onChange={() => {}} />
												);
											}

										})}
										
										<Grid cols='12 12 12 12'>
											<div style={{ display: 'flex', flexDirection: 'row' }}>
												{compartimentos.map((compartimento, i) => {

													return (
														<div key={compartimento.id} 
															style={{ 
																width: compartimento.tamanho, 
																margin: 2,
																textAlign: 'center',
																fontWeight: 'bold'
															}}>
															{i+1} - {compartimento.capacidade} L
														</div>
													);
												})}
											</div>
											<div style={{ display: 'flex', flexDirection: 'row' }}>
												{compartimentos.map(compartimento => {

													return (
														<div key={compartimento.id} 
															style={{ 
																backgroundColor: '#e3e3e3', 
																height: 80, 
																width: compartimento.tamanho, 
																margin: 2,
																display: 'flex',
																flexDirection: 'row',
																alignItems: 'end',
																borderRadius: 5,
															}}>
															{/*
																1 - OLEO DIESEL B S10 ADITIVA
																3 - OLEO DIESEL B S500 ADITIVADO
															*/}
															<div 
																style={{
																	backgroundColor: this.getCor(compartimento.id_produto) /*parseFloat(veiculo ? veiculo.capacidade : 0) - quantidadeGeral < 0 ? '#f55656' : '#36d184'*/, 
																	height: compartimento.capacidade ? (compartimento.ocupacao * 80) / compartimento.capacidade : 0, 
																	width: '100%', 
																	margin: 2,
																	borderRadius: 6,
																	textAlign: 'center'
																}}>
																<div 
																	style={(compartimento.capacidade ? (compartimento.ocupacao * 80) / compartimento.capacidade : 0) < 20 
																		? { position: 'relative', top: -20 } 
																		: {}
																	} >
																	{FormatUtils.formatarValorTelaDecimal(compartimento.ocupacao,0)} L
																</div>
															</div>
														</div>
													);
												})}
											</div>

											<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingLeft: 5, paddingRight: 5, marginBottom: 8 }}>
												<div>Dianteira</div>
												<div>Traseira</div>												
											</div>

											{alertas.map(alerta => (
												<div class='alert alert-warning alert-dismissible' style={{ paddingTop: 20 }}>
													<h5 style={{ fontSize: 12 }}><i class='icon fas fa-exclamation-triangle'></i> {alerta}</h5>
												</div>
											))}
										</Grid>
						
									</Row>
								</Grid>

								<Grid cols='12 6 6 6'>
									<Row>
										<Grid cols='6 6 6 6'>
											<Row style={{ backgroundColor: this.getCor(1) }}>
												<Field
													name='id_distribuidora_s10'
													component={SelectDefault}
													options={this.props.listaDistribuidora}
													label='S10'
													cols='12 8 8 8'
													placeholder='Selecione a distribuidora'
													readOnly={'readOnly'} />

												<LabelAndInput
													label='Preço' 
													placeholder=''
													cols='12 4 4 4'
													readOnly={'readOnly'}
													value={FormatUtils.formatarValorTela(parseFloat(precoUnitarioS10 || 0) + parseFloat(this.props.formularioValues.custo_operacao || 0), 4)}
													onChange={data => {										
																	
													}} />
											</Row> 
											<Row style={{ backgroundColor: this.getCor(3) }}>
												<Field
													name='id_distribuidora_s500'
													component={SelectDefault}
													options={this.props.listaDistribuidora}
													label='S500'
													cols='12 8 8 8'
													placeholder='Selecione a distribuidora'
													readOnly={'readOnly'} />
													
												<LabelAndInput
													label='Preço' 
													placeholder=''
													cols='12 4 4 4'
													readOnly={'readOnly'}
													value={FormatUtils.formatarValorTela(parseFloat(precoUnitarioS500 || 0) + parseFloat(this.props.formularioValues.custo_operacao || 0), 4)}
													onChange={data => {										
																	
													}} />
											</Row> 
										</Grid>
										<Grid cols='6 6 6 6'>
											<Row style={{ backgroundColor: this.getCor(6) }}>
												<Field
													name='id_distribuidora_gasolina'
													component={SelectDefault}
													options={this.props.listaDistribuidora}
													label='Gasolina'
													cols='12 8 8 8'
													placeholder='Selecione a distribuidora'
													readOnly={'readOnly'} />

												<LabelAndInput
													label='Preço' 
													placeholder=''
													cols='12 4 4 4'
													readOnly={'readOnly'}
													value={FormatUtils.formatarValorTela(parseFloat(precoUnitarioGasolina || 0) + parseFloat(this.props.formularioValues.custo_operacao || 0), 4)}
													onChange={data => {										
																	
													}} />
											</Row> 
											<Row style={{ backgroundColor: this.getCor(7) }}>
												<Field
													name='id_distribuidora_etanol'
													component={SelectDefault}
													options={this.props.listaDistribuidora}
													label='Etanol'
													cols='12 8 8 8'
													placeholder='Selecione a distribuidora'
													readOnly={'readOnly'} />
													
												<LabelAndInput
													label='Preço' 
													placeholder=''
													cols='12 4 4 4'
													readOnly={'readOnly'}
													value={FormatUtils.formatarValorTela(parseFloat(precoUnitarioEtanol || 0) + parseFloat(this.props.formularioValues.custo_operacao || 0), 4)}
													onChange={data => {										
																	
													}} />
											</Row> 
										</Grid>
									</Row>
									<Row>									

										<LabelAndInput
											label='Custo Operação' 
											placeholder=''
											cols='12 12 4 4'
											readOnly={'readOnly'}
											value={FormatUtils.formatarValorTela(custoOperacaoGeral, 4)}
											onChange={data => {										
															
											}} />

										<LabelAndInput
											label='Custo Frete' 
											placeholder=''
											cols='12 12 4 4'
											readOnly={'readOnly'}
											value={FormatUtils.formatarValorTela(custoFreteGeral, 4)}
											onChange={data => {										
															
											}} />

										<LabelAndInput
											label='Custo Entrega (Km)' 
											placeholder=''
											cols='12 12 4 4'
											readOnly={'readOnly'}
											value={FormatUtils.formatarValorTela(custoEntregaGeral, 4)}
											onChange={data => {										
															
											}} />

										<LabelAndInput
											label='Margem Mínima' 
											placeholder=''
											cols='12 12 6 6'
											readOnly={'readOnly'}
											value={FormatUtils.formatarValorTela(margemMinimaGeral, 4)}
											onChange={data => {										
															
											}} />
										
										<LabelAndInput
											label='Margem Média' 
											placeholder=''
											cols='12 12 6 6'
											readOnly={'readOnly'}
											value={FormatUtils.formatarValorTela(margemMediaGeral, 4)}
											onChange={data => {										
															
											}} />

									</Row>
									<Row style={{ backgroundColor: corMargem }}>
										<LabelAndInput
											label='Margem Líquida' 
											placeholder=''
											cols='12 12 6 6'
											readOnly={'readOnly'}
											value={FormatUtils.formatarValorTela(margemLiquidaGeral, 4)}
											onChange={data => {										
															
											}} />
										
										<LabelAndInput
											label='Lucro Líquido' 
											placeholder=''
											cols='12 12 6 6'
											readOnly={'readOnly'}
											value={FormatUtils.formatarValorTelaDecimal(lucroLiquidoGeral, 2)}
											onChange={data => {										
															
											}} />

										{/* 
										
										<LabelAndInput
											label='Quantidade Total' 
											placeholder=''
											cols='12 12 4 4'
											readOnly={'readOnly'}
											value={FormatUtils.formatarValorTelaDecimal(quantidadeGeral, 2)}
											onChange={data => {										
															
											}} />

										<LabelAndInput
											label='Quantidade p/ Completar' 
											placeholder=''
											cols='12 12 4 4'
											readOnly={'readOnly'}
											value={FormatUtils.formatarValorTelaDecimal(parseFloat(veiculo ? veiculo.capacidade : 0) - quantidadeGeral, 2)}
											onChange={data => {										
															
											}} /> 

										<LabelAndInput
											label='Valor Total' 
											placeholder=''
											cols='12 12 12 12'
											readOnly={'readOnly'}
											value={FormatUtils.formatarValorTelaDecimal(valorTotalGeral, 2)}
											onChange={data => {										
															
											}} />
											
										<LabelAndInput
											label='Custo Total' 
											placeholder=''
											cols='12 12 12 12'
											readOnly={'readOnly'}
											value={FormatUtils.formatarValorTelaDecimal(valorTotalGeral - lucroLiquidoGeral, 2)}
											onChange={data => {										
															
											}} />

										<LabelAndInput
											label='Lucro Bruto' 
											placeholder=''
											cols='12 12 12 12'
											readOnly={'readOnly'}
											value={FormatUtils.formatarValorTelaDecimal(lucroTotalGeral, 2)}
											onChange={data => {										
															
											}} />
											
										*/}
									</Row>
								</Grid>
							</Row>
								
							<br />

							<Row>

								{this.props.formularioValues.id_distribuidora_s10 && this.props.formularioValues.id_distribuidora_s500 ? (								
									<Grid cols='6 6 4 2'>
										<Button
											text='Adicionar Item'
											type={'success'}
											icon={'fa fa-plus'}
											disabled={this.props.formularioValues.id && this.props.formularioValues.id_status != 1 && this.props.formularioValues.id_status != 2}
											event={() => {
												let lista = (this.props.formularioValues.itens || []).map(item => item);
												lista.push({ idAux: new Date().getTime(), ativo: true, ordem: lista.length + 1 });
												this.props.initForm({
													...this.props.formularioValues,
													itens: lista
												});
											}} />
									</Grid>
								) : null}
								
							</Row>

							{(this.props.formularioValues.itens || []).filter(item => item.ativo).map((item, i) => {
								
								let valorTotalBase = parseFloat(FormatUtils.formatarValorBanco(item.preco_unitario_base, 4))
									* parseFloat(FormatUtils.formatarValorBanco(item.quantidade, 2));

								let percentualBase = parseFloat(parseFloat(FormatUtils.formatarValorBanco(item.valor_total, 2)) > 0 ? 100 - ((valorTotalBase * 100) / parseFloat(FormatUtils.formatarValorBanco(item.valor_total, 2)))
									: 0).toFixed(2);

								let precoUnitario = parseFloat(FormatUtils.formatarValorBanco(item.preco_unitario, 4));
								let precoUnitarioBase = parseFloat(FormatUtils.formatarValorBanco(item.preco_unitario_base, 4));
								let precoUnitarioFrete = parseFloat(FormatUtils.formatarValorBanco(item.preco_unitario_frete, 4));
								let precoUnitarioPrazo = parseFloat(FormatUtils.formatarValorBanco(item.preco_prazo, 4));

								let margemBruta = precoUnitario - precoUnitarioBase;

								let endereco = this.props.listaEndereco.filter(endereco => endereco.id == item.id_endereco)[0];

								//1 - OLEO DIESEL B S10 ADITIVA / 3 - OLEO DIESEL B S500 ADITIVADO / 6 - GASOLINA / 7 - ETANOL

								return (
									<Row key={item.id || item.idAux} 
										style={{ paddingTop: 8, marginTop: 8, backgroundColor: this.getCor(item.id_produto) }}>
										<Grid cols='10 10 11 11'>									
											<Row>
												{!item.expandido &&
												<Select
													options={[{ id: 1, valor: 'Sim' }, { id: 2, valor: 'Não' }]}
													cols='12 2 1 1'
													label={'Confirmado'}
													placeholder='Selecione'
													value={item.confirmado ? 1 : 2}
													readOnly={readOnly}
													onChange={(data) => {
														this.props.initForm({
															...this.props.formularioValues,
															itens: this.props.formularioValues.itens.map(itemAux => {
																if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																	return {
																		...itemAux,
																		confirmado: data == 1
																	}
																} else {
																	return itemAux;
																}
															})
														});
													}} />}

												<Select
													options={this.props.listaCliente}
													cols='12 6 3 3'
													label={'Cliente'}
													placeholder='Selecione o cliente'
													value={item.id_cliente}
													readOnly={readOnly}
													onChange={(data) => {
														this.props.initForm({
															...this.props.formularioValues,
															itens: this.props.formularioValues.itens.map(itemAux => {
																if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																	return {
																		...itemAux,
																		id_cliente: data
																	}
																} else {
																	return itemAux;
																}
															})
														});
													}} />
												
												{!item.expandido &&
												<Select
													options={this.props.listaEndereco.filter(endereco => endereco.id_cliente == item.id_cliente)}
													cols='12 6 3 3'
													label={'Endereço'}
													placeholder='Selecione o endereço'
													value={item.id_endereco}
													onChange={(data) => {
														this.props.initForm({
															...this.props.formularioValues,
															itens: this.props.formularioValues.itens.map(itemAux => {
																if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {

																	const endereco = this.props.listaEndereco.filter(endereco => endereco.id == data)[0];

																	return {
																		...itemAux,
																		id_endereco: data,
																		whatsapp_entrega: endereco ? endereco.whatsapp_entrega : null
																	}
																} else {
																	return itemAux;
																}
															})
														});
													}} />}
												
												<Select
													options={this.props.listaProduto}
													cols='12 6 3 3'
													label={'Produto'}
													placeholder='Selecione o produto'
													value={item.id_produto}
													readOnly={readOnly}
													onChange={(data) => {

														let politicaSelecionada = this.props.listaPoliticaPreco.filter(politica => 
															politica.id_unidade == this.props.formularioValues.id_unidade
															&& politica.id_produto == data)[0];


														this.props.initForm({
															...this.props.formularioValues,
															itens: this.props.formularioValues.itens.map(itemAux => {
																if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																	return {
																		...itemAux,
																		id_produto: data,
																		preco_unitario_bruto: politicaSelecionada ? FormatUtils.formatarValorTela(politicaSelecionada.preco_bruto, 4) : null,
																		preco_unitario_base: politicaSelecionada ? FormatUtils.formatarValorTela(parseFloat(politicaSelecionada.preco) - parseFloat(politicaSelecionada.preco_frete), 4) : null,
																		preco_unitario: politicaSelecionada ? FormatUtils.formatarValorTela(politicaSelecionada.preco, 4) : 0,
																		preco_unitario_frete: politicaSelecionada ? FormatUtils.formatarValorTela(politicaSelecionada.preco_frete, 4) : null,
																	}
																} else {
																	return itemAux;
																}
															})
														}, true);
													}} />

												{!item.expandido && 
												<LabelAndInputNumber
													label='Última Venda' 
													placeholder=''
													cols='12 6 2 2'
													casas={4}
													readOnly={'readOnly'}
													value={endereco ? (item.id_produto == 1 && endereco.ultimo_preco_s10
														? FormatUtils.formatarValorTela(endereco.ultimo_preco_s10, 4) 
															: (item.id_produto == 3 && endereco.ultimo_preco_s500 
																? FormatUtils.formatarValorTela(endereco.ultimo_preco_s500, 4) : '') 
														) : ''}
													onChange={data => {
													}} />}

												<LabelAndInputNumber
													label={!item.expandido ? `Quantidade` 
													: `Quantidade - Compart: ${compartimentos.filter(compartimento => 
														(item.compartimentos || []).includes(compartimento.id)
													).map(compartimento => compartimento.valor.replace('Compartimento ', '')).join(' e ') || 'Nenhum'}`}
													placeholder='Informe o quantidade'
													cols='12 6 2 2'
													maxWidth={item.expandido ? null : 150}
													casas={2}
													readOnly={readOnly}
													value={item.quantidade}
													onChange={data => {
														this.props.initForm({
															...this.props.formularioValues,
															itens: this.props.formularioValues.itens.map(itemAux => {
																if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																	return {
																		...itemAux,
																		quantidade: data.target.value
																	}
																} else {
																	return itemAux;
																}
															})
														}, true);
													}} />
												
												{!item.expandido &&
												<Select
													options={this.props.listaPedidoPrazo}
													cols='12 6 3 3'
													maxWidth={250}
													label={'Prazo'}
													placeholder='Selecione o prazo'
													value={item.id_prazo}
													readOnly={readOnly}
													onChange={value => {

														const prazoSelecionado = this.props.listaPedidoPrazo.filter(itemPrazo => itemPrazo.id == value)[0];
														const prazoDias = parseInt(prazoSelecionado ? prazoSelecionado.dias : 0);

														let precoBasePrazo = this.props.listaCustoPrazo.filter(item => item.dias == prazoDias)[0];

														this.props.initForm({
															...this.props.formularioValues,
															itens: this.props.formularioValues.itens.map(itemAux => {
																if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																	return {
																		...itemAux,
																		id_prazo: prazoSelecionado ? prazoSelecionado.id : null,
																		prazo: prazoDias,
																		preco_base_prazo: precoBasePrazo ? precoBasePrazo.valor : 0
																	}
																} else {
																	return itemAux;
																}
															})
														}, true);
													}} />}
												
												{!item.expandido ? (
													<LabelAndInputNumber
														label='Dias' 
														placeholder='Informe o Prazo'
														cols='12 6 2 2'
														maxWidth={80}
														casas={0}
														readOnly={readOnly}
														value={item.prazo}
														onChange={data => {

															let precoBasePrazo = this.props.listaCustoPrazo.filter(item => item.dias == data.target.value)[0];

															this.props.initForm({
																...this.props.formularioValues,
																itens: this.props.formularioValues.itens.map(itemAux => {
																	if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																		return {
																			...itemAux,
																			prazo: data.target.value,
																			preco_base_prazo: precoBasePrazo ? precoBasePrazo.valor : 0
																		}
																	} else {
																		return itemAux;
																	}
																})
															}, true);
														}} />
												) : (
													<LabelAndInputNumber
														label='Prazo' 
														placeholder='Informe o Prazo'
														cols='12 6 1 1'														
														maxWidth={80}
														casas={0}
														readOnly={readOnly}
														value={item.prazo}
														onChange={data => {

															let precoBasePrazo = this.props.listaCustoPrazo.filter(item => item.dias == data.target.value)[0];

															this.props.initForm({
																...this.props.formularioValues,
																itens: this.props.formularioValues.itens.map(itemAux => {
																	if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																		return {
																			...itemAux,
																			prazo: data.target.value,
																			preco_base_prazo: precoBasePrazo ? precoBasePrazo.valor : 0
																		}
																	} else {
																		return itemAux;
																	}
																})
															}, true);
														}} />
												)}

												<LabelAndInputNumber
													label='Preço Unitário' 
													placeholder='Informe o preço'
													cols='12 6 2 2'
													maxWidth={140}
													casas={4}
													readOnly={readOnly}
													value={item.preco_unitario}
													onChange={data => {
														this.props.initForm({
															...this.props.formularioValues,
															itens: this.props.formularioValues.itens.map(itemAux => {
																if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																	return {
																		...itemAux,
																		preco_unitario: data.target.value
																	}
																} else {
																	return itemAux;
																}
															})
														}, true);
													}} />

												{!item.expandido &&
												<LabelAndInputNumber
													label='Preço Sugerido' 
													placeholder='Informe o preço'
													cols='12 6 2 2'
													maxWidth={140}
													casas={4}
													readOnly={'readOnly'}
													value={FormatUtils.formatarValorTela(
														this.props.formularioValues.fob 
															? precoUnitarioPrazo + precoUnitarioFrete + custoOperacaoGeral + custoFreteGeral
															: precoUnitarioPrazo + precoUnitarioFrete + custoOperacaoGeral + custoFreteGeral + custoEntregaGeral
														, 4)}
													onChange={data => {
														
													}} />}
													
												{!item.expandido &&
												<LabelAndInputNumber
													label='Valor Total' 
													placeholder='Informe o valor'
													cols='12 6 2 2'
													maxWidth={180}
													casas={2}
													readOnly={'readOnly'}
													value={item.valor_total}
													onChange={data => {										
														this.props.initForm({
															...this.props.formularioValues,
															itens: this.props.formularioValues.itens.map(itemAux => {
																if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																	return {
																		...itemAux,
																		valor_total: data.target.value
																	}
																} else {
																	return itemAux;
																}
															})
														});
													}} />}
											
												{!item.expandido ? (
													<LabelAndInput
														label='Margem Bruta' 
														placeholder=''
														cols='12 6 4 2'
														maxWidth={140}
														readOnly={'readOnly'}
														value={FormatUtils.formatarValorTela(margemBruta, 4)}
														onChange={data => {										
															
														}} />
												) : (
													<LabelAndInput
														label='Margem Bruta' 
														placeholder=''
														cols='12 6 2 1'
														maxWidth={140}
														readOnly={'readOnly'}
														value={FormatUtils.formatarValorTela(margemBruta, 4)}
														onChange={data => {										
															
														}} />
												)}
													
												{!item.expandido &&
												<LabelAndInput
													label='Observação' 
													placeholder='Informe a observação'
													cols='12 12 8 10'
													casas={2}
													readOnly={acessoLogistica ? null : readOnly}
													value={item.observacao}
													onChange={data => {
														this.props.initForm({
															...this.props.formularioValues,
															itens: this.props.formularioValues.itens.map(itemAux => {
																if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																	return {
																		...itemAux,
																		observacao: data.target.value
																	}
																} else {
																	return itemAux;
																}
															})
														});
													}} />}

												{!item.expandido &&
												<Select
													name='compartimentos'
													label='Compartimentos'
													placeholder='Informe os compartimentos'
													cols='12 12 4 2'
													multiple
													readOnly={readOnly}
													options={compartimentos.filter(compartimento => {														
														return (
															!compartimento.ocupacao 
															|| (
																compartimento.ocupacao > 0
																&& (compartimento.capacidade - compartimento.ocupacao) >= parseFloat(FormatUtils.formatarValorBanco(item.quantidade, 2)) 
																&& compartimento.id_produto == item.id_produto
															)
															// !compartimentosOcupados.includes(compartimento.id) 
															|| (item.compartimentos || []).includes(compartimento.id)
														);
													})}
													value={compartimentos.map(compartimento => ({ value: compartimento.id, label: compartimento.valor })).filter(compartimento => (item.compartimentos || []).includes(compartimento.value))}
													onChange={value => {
														this.props.initForm({
															...this.props.formularioValues,
															itens: this.props.formularioValues.itens.map(itemAux => {
																if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																	return {
																		...itemAux,
																		compartimentos: value.map(item => item.value)
																	}
																} else {
																	return itemAux;
																}
															})
														});
													}} />}

												{!item.expandido &&
												<LabelAndInput
													label='Observação Auxiliar' 
													placeholder='Informe a observação'
													cols='12 12 12 12'
													casas={2}
													readOnly={acessoLogistica ? null : readOnly}
													value={item.observacao2}
													onChange={data => {
														this.props.initForm({
															...this.props.formularioValues,
															itens: this.props.formularioValues.itens.map(itemAux => {
																if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																	return {
																		...itemAux,
																		observacao2: data.target.value
																	}
																} else {
																	return itemAux;
																}
															})
														});
													}} />}
												
												{(!item.expandido && this.props.formularioValues.id_status && ![1, 2, 3].includes(this.props.formularioValues.id_status)) && //Digitando, Aguardando Aprovação e Rejeitado
												<LabelAndInputMask
													label='Data Emissão NF-e' 
													placeholder='Informe a data'
													cols='6 6 4 3'
													readOnly={readOnly}
													mask='99/99/9999'
													maxWidth={180}
													value={item.data_emissao_nfe}
													onChange={data => {
														this.props.initForm({
															...this.props.formularioValues,
															itens: this.props.formularioValues.itens.map(itemAux => {
																if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																	return {
																		...itemAux,
																		data_emissao_nfe: data.target.value
																	}
																} else {
																	return itemAux;
																}
															})
														});
													}} />}
												
												{(!item.expandido && this.props.formularioValues.id_status && ![1, 2, 3].includes(this.props.formularioValues.id_status)) && //Digitando, Aguardando Aprovação e Rejeitado
												<LabelAndInput
													label='Número NF-e' 
													placeholder='Informe o número'
													cols='6 6 4 3'
													readOnly={readOnly}
													maxWidth={180}
													value={item.numero_nfe}
													onChange={data => {
														this.props.initForm({
															...this.props.formularioValues,
															itens: this.props.formularioValues.itens.map(itemAux => {
																if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																	return {
																		...itemAux,
																		numero_nfe: data.target.value
																	}
																} else {
																	return itemAux;
																}
															})
														});
													}} />}

												{!item.expandido &&
												<LabelAndInputMask
													label='Previsão de Entrega' 
													placeholder='Informe a data'
													cols='6 6 4 3'
													mask='99/99/9999 99:99'
													maxWidth={180}
													value={item.datahora_previsao_entrega}
													onChange={data => {
														this.props.initForm({
															...this.props.formularioValues,
															itens: this.props.formularioValues.itens.map(itemAux => {
																if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																	return {
																		...itemAux,
																		datahora_previsao_entrega: data.target.value
																	}
																} else {
																	return itemAux;
																}
															})
														});
													}} />}

												{!item.expandido &&
												<LabelAndInputMask
													label='WhatsApp' 
													placeholder='Informe'
													cols='6 6 4 3'
													mask='(99) 99999-9999'
													maxWidth={180}
													value={item.whatsapp_entrega}
													onChange={data => {
														this.props.initForm({
															...this.props.formularioValues,
															whatsapp_entrega_editado: true,
															itens: this.props.formularioValues.itens.map(itemAux => {
																if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																	return {
																		...itemAux,
																		whatsapp_entrega: data.target.value,
																		whatsapp_entrega_editado: true
																	}
																} else {
																	return itemAux;
																}
															})
														});
													}} />}

												{!item.expandido &&
												<Select
													options={this.props.listaPedidoTipo}
													cols='12 6 3 2'
													label={'Configuração'}
													placeholder='Selecione'
													value={item.id_tipo}
													readOnly={readOnly}
													onChange={(data) => {
														this.props.initForm({
															...this.props.formularioValues,
															itens: this.props.formularioValues.itens.map(itemAux => {
																if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																	return {
																		...itemAux,
																		id_tipo: data
																	}
																} else {
																	return itemAux;
																}
															})
														}, true);
													}} />}

												{!item.expandido &&
												<Select
													options={this.props.listaPedidoFrete}
													cols='12 6 3 2'
													label={'Frete'}
													placeholder='Selecione'
													value={item.id_frete}
													readOnly={readOnly}
													onChange={(data) => {
														this.props.initForm({
															...this.props.formularioValues,
															itens: this.props.formularioValues.itens.map(itemAux => {
																if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																	return {
																		...itemAux,
																		id_frete: data
																	}
																} else {
																	return itemAux;
																}
															})
														}, true);
													}} />}

												{(!item.expandido && ![1, 3].includes(item.id_produto)) &&
												<Select
													options={this.props.listaPedidoCnpj}
													cols='12 6 3 2'
													label={'CNPJ Posto'}
													placeholder='Selecione'
													value={item.cnpj_posto}
													readOnly={readOnly}
													onChange={(data) => {
														this.props.initForm({
															...this.props.formularioValues,
															itens: this.props.formularioValues.itens.map(itemAux => {
																if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																	return {
																		...itemAux,
																		cnpj_posto: data
																	}
																} else {
																	return itemAux;
																}
															})
														}, true);
													}} />}

												{(!item.expandido && [7].includes(this.props.formularioValues.id_status)) && //Finalizado Base
												<div>
													<a class={`btn btn-app bg-${item.imagem_nfe ? 'success' : 'secondary'}`}
														style={{ marginTop: 9 }}
														onClick={() => {
															if (item.imagem_nfe) {
																window.open(`${consts.URL}/${item.imagem_nfe}`, '_blank');
															} else {
																setError('Foto da Nota Fiscal não foi anexada');
															}
														}}>
														<i class='fas fa-paperclip'></i> Nota Fiscal
													</a>

													<a class={`btn btn-app bg-${item.imagem_checklist ? 'success' : 'secondary'}`}
														style={{ marginTop: 9 }}
														onClick={() => {
															if (item.imagem_nfe) {
																window.open(`${consts.URL}/${item.imagem_checklist}`, '_blank');
															} else {
																setError('Foto do Checklist não foi anexada');
															}
														}}>
														<i class='fas fa-paperclip'></i> Checklist
													</a>

												</div>}

												{/* 
												
												<LabelAndInput
													label='Lucro Bruto' 
													placeholder=''
													cols='12 6 4 3'
													readOnly={'readOnly'}
													value={FormatUtils.formatarValorTela(parseFloat(FormatUtils.formatarValorBanco(item.quantidade, 2)) * margemBruta, 2)}
													onChange={data => {										
														
													}} /> 
												
												<LabelAndInputNumber
													label='Preço Unitário (sem frete)' 
													placeholder='Informe o preço'
													cols='12 6 4 2'
													casas={4}
													readOnly={'readOnly'}
													value={item.preco_unitario_bruto}
													onChange={data => {
														
													}} />

												<LabelAndInputNumber
													label='Preço Unitário Base' 
													placeholder='Informe o preço'
													cols='12 6 4 2'
													casas={4}
													readOnly={'readOnly'}
													value={item.preco_unitario_base}
													onChange={data => {
														
													}} />
												*/}
											</Row>
										</Grid>
										<Grid cols='2 2 1 1' 
											style={{
												display: 'flex',
												flexDirection: 'column',
												alignItems: 'center',
												justifyContent: 'center'
											}}>

											<div 
												style={{
													display: 'flex',
													flexDirection: 'row',
													alignItems: 'center',
													justifyContent: 'center',
													marginBottom: 4
												}} >

												<ButtonTable
													type={'success'}
													icon={'fas fa-chevron-up'}
													visible={true}
													disabled={(this.props.formularioValues.id && this.props.formularioValues.id_status != 1 
																&& this.props.formularioValues.id_status != 2 && !acessoLogistica) 
														|| i == 0}
													event={() => {

														let lista = this.props.formularioValues.itens.map((itemAux, j) => {
															if (i == j) {
																return {
																	...itemAux,
																	ordem: itemAux.ordem - 1
																}
															} else if (i - 1 == j) {
																return {
																	...itemAux,
																	ordem: itemAux.ordem + 1
																}
															} else {
																return itemAux;
															}
														});
																										
														lista.sort((a, b) => a.ordem < b.ordem ? -1 : 1);

														this.props.initForm({
															...this.props.formularioValues,
															itens: lista
														});
													}} />
												
												<ButtonTable
													type={'success'}
													icon={'fas fa-chevron-down'}
													visible={true}
													disabled={(this.props.formularioValues.id && this.props.formularioValues.id_status != 1 
																&& this.props.formularioValues.id_status != 2 && !acessoLogistica) 
														|| i == this.props.formularioValues.itens.length - 1}
													event={() => {
														let lista = this.props.formularioValues.itens.map((itemAux, j) => {
															if (i == j) {
																return {
																	...itemAux,
																	ordem: itemAux.ordem + 1
																}
															} else if (i + 1 == j) {
																return {
																	...itemAux,
																	ordem: itemAux.ordem - 1
																}
															} else {
																return itemAux;
															}
														});
																										
														lista.sort((a, b) => a.ordem < b.ordem ? -1 : 1);

														this.props.initForm({
															...this.props.formularioValues,
															itens: lista
														});
													}} />
											</div>
											
											{!item.expandido &&
											<div 
												style={{
													display: 'flex',
													flexDirection: 'row',
													alignItems: 'center',
													justifyContent: 'center',
													marginBottom: 4
												}} >										
												<ButtonTable
													type={'primary'}
													icon={'fas fa-file-pdf'}
													title='Imprimir'
													visible={true}
													disabled={false}
													event={() => {
														this.setState({
															...this.state,
															modalImprimir: {
																id: item.id || item.idAux
															}
														});
													}} />
												<ButtonTable
													type={'primary'}
													icon={'fas fa-copy'}
													title='Copiar mensagem'
													visible={true}
													disabled={false}
													event={() => {
														
														const produto = this.props.listaProduto.filter(produto => produto.id == item.id_produto)[0];
														const endereco = this.props.listaEndereco.filter(endereco => endereco.id == item.id_endereco)[0];
														
														let mensagem =
															`*VALOR ATUALIZADO DIESEL ADITIVADO*`
															+ `\n\n`
															+ `Produto: ${produto ? produto.valor : 'Não informado'}`
															+ `\n`
															+ `Quantidade: ${item.quantidade} L`
															+ `\n`
															+ `Preço Unitário: R$ ${item.preco_unitario}`
															+ `\n`
															+ `Prazo: ${item.prazo > 0 ? item.prazo : ''} ${item.prazo > 0 ? (item.prazo == 1 ? 'dia' : 'dias') : 'À vista'}`
															+ `\n\n`
															+ `Nome: ${endereco ? endereco.razao_social : 'Não informado'}`
															+ `\n`
															+ `Endereço: ${endereco ? endereco.valor : 'Não informado'}`
															+ `\n\n\n`
															+ `*Preço sujeito à alteração caso haja reajuste das companhias / governo estadual*`;
															
														navigator.clipboard.writeText(mensagem);

														setSuccess('Mensagem copiada');

													}} />
											</div>}

											{!item.expandido &&
											<div 
												style={{
													display: 'flex',
													flexDirection: 'row',
													alignItems: 'center',
													justifyContent: 'center',
													marginBottom: 4
												}} >										
												<ButtonTable
													type={'primary'}
													icon={'fas fa-map-marker-alt'}
													title='Localização'
													visible={true}
													disabled={false}
													event={() => {
														let endereco = this.props.listaEndereco.filter(endereco => endereco.id == item.id_endereco)[0];

														if (endereco && endereco.latitude && endereco.longitude) {
															window.open(`https://www.google.com/maps/place/${endereco.latitude},${endereco.longitude}`, '_blank', 'noreferrer');
														} else {
															window.alert('Localização não encontrada');
														}
													}} />
												<ButtonTable
													type={'primary'}
													icon={'fas fa-id-card'}
													title='Mais infirmações'
													visible={true}
													disabled={false}
													event={() => {
														
														if (item.id_endereco) {															
															this.setState({
																...this.state,
																modalEnderecoInformacoes: {
																	id_endereco: item.id_endereco
																}
															});

															this.props.carregarEndereco(item.id_endereco);
														} else {
															window.alert('Localização não encontrada');
														}

													}} />
											</div>}

											<div 
												style={{
													display: 'flex',
													flexDirection: 'row',
													alignItems: 'center',
													justifyContent: 'center'
												}} >										
												<ButtonTable
													type={'primary'}
													icon={item.expandido ? 'fas fa-expand' : 'fas fa-compress'}
													visible={true}
													disabled={false}
													event={() => {
														this.props.initForm({
															...this.props.formularioValues,
															itens: this.props.formularioValues.itens.map(itemAux => {
																if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																	return {
																		...itemAux,
																		expandido: !itemAux.expandido
																	}
																} else {
																	return itemAux;
																}
															})
														});
													}} />

												<ButtonTable
													type={'danger'}
													icon={'fas fa-trash-alt'}
													visible={true}
													disabled={this.props.formularioValues.id && this.props.formularioValues.id_status != 1 
															&& this.props.formularioValues.id_status != 2}
													event={() => {
														if (this.props.formularioValues.simulador) {
															this.props.initForm({
																...this.props.formularioValues,
																itens: this.props.formularioValues.itens.map(itemAux => {
																	if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																		return {
																			...itemAux,
																			ativo: false
																		}
																	} else {
																		return itemAux;
																	}
																})
															});
														} else {
															this.setState({
																...this.state,
																itemVendaPerdida: { ...item }
															});
														}
													}} />
													
											</div>

										</Grid>
									</Row>
								)
							})}

							<br />
							
						</ContentCardBody>
					) : (
						<ContentCardBody>
							<Row>

								<Select
									options={this.props.listaStatus}
									label='Status'
									cols='12 6 4 4'
									placeholder='Selecione o status'
									readOnly={null}
									value={this.props.formularioValues.id_status}
									onChange={data => {
										if (data) {
											let registro = { 
												...this.props.formularioValues,
												id_status: data
											};
											//Aprovado
											if (data == 4) {
												registro = {
													...registro,
													id_usuario_logistica: null,
													id_usuario_entrega: null,
													datahora_logistica: null,
													datahora_entrega: null
												}
											}
											//Logística Parcial
											if (data == 5) {
												registro = {
													...registro,
													id_usuario_logistica: null,
													id_usuario_entrega: null,
													datahora_logistica: null,
													datahora_entrega: null
												}
											}
											//Logística Finalizada
											if (data == 6) {
												registro = {
													...registro,
													id_usuario_logistica: this.props.sessao.id,
													id_usuario_entrega: null,
													datahora_logistica: DateFormat.getDataHoraAtual(),
													datahora_entrega: null
												}
											}
											//Entrega
											if (data == 7) {
												registro = {
													...registro,
													id_usuario_entrega: this.props.sessao.id,
													datahora_entrega: DateFormat.getDataHoraAtual()
												}
											}
											this.props.salvar(registro);
										}
								}} />

								<SelectDefault
									name='id_unidade'
									options={this.props.listaUnidade}
									label='Unidade'
									cols='12 6 3 4'
									placeholder='Selecione o unidade'
									readOnly={'readOnly'}
									value={this.props.formularioValues.id_unidade}
									onChange={data => {
								
									}} />

								<Field
									name='giro'
									component={LabelAndInputNumber}
									label='Giro' placeholder='Informe o giro'
									cols='12 4 2 1'
									casas={0}
									readOnly={'readOnly'} />
						
								<SelectDefault
									name='id_veiculo'
									options={this.props.listaVeiculo}
									label='Veículo'
									cols='12 8 3 3'
									placeholder='Selecione o veículo'
									readOnly={'readOnly'}
									value={this.props.formularioValues.id_veiculo}
									onChange={data => {
								
									}} />

								{(veiculo && veiculo.documentacao_vencida) && (
									<Grid cols='12 12 12 12'>
										<div class="alert alert-danger alert-dismissible">
											<h6><i class="icon fas fa-ban"></i> Veículo possui problemas na documentação!</h6>
										</div>
									</Grid>
								)}
											
								<Field
									name='rota_link'
									component={LabelAndInput}
									label='Link da Rota' placeholder='Informe o link'
									cols='12 12 12 12'
									readOnly={'readOnly'} />
								
								{(this.props.formularioValues.itens || []).filter(item => item.ativo).map((item, i) => {
								
									let cliente = this.props.listaCliente.filter(cliente => cliente.id == item.id_cliente)[0];
									let endereco = this.props.listaEndereco.filter(endereco => endereco.id == item.id_endereco)[0];

									if (endereco && cliente && endereco.croqui) {
										return (
											<LabelAndInput
												name='croqui'
												component={LabelAndInput}
												label={`Croqui ${cliente.valor}`} placeholder='Croqui'
												cols='12 12 12 12'
												readOnly={'readOnly'}
												value={endereco.croqui}
												onChange={() => {}} />
										);
									}

								})}
								<br />

							</Row>

							{(this.props.formularioValues.itens || []).filter(item => item.ativo).map((item, i) => {
								
								return (
									<Row key={item.id || item.idAux} 
										style={{ paddingTop: 8, marginTop: 8, backgroundColor: this.getCor(item.id_produto) }}>
										<Grid cols='12 12 12 12'>									
											<Row>								
												<SelectDefault
													options={this.props.listaCliente}
													cols='12 6 3 3'
													label={'Cliente'}
													placeholder='Selecione o cliente'
													readOnly={'readOnly'}
													value={item.id_cliente}
													onChange={(data) => {
														
													}} />												
												
												<SelectDefault
													options={this.props.listaProduto}
													cols='12 6 2 1'
													label={'Produto'}
													placeholder='Selecione o produto'
													readOnly={'readOnly'}
													value={item.id_produto}
													onChange={(data) => {

													}} />

												<LabelAndInputNumber
													label='Quantidade' 
													placeholder='Informe o quantidade'
													cols='12 6 2 1'
													casas={2}
													readOnly={'readOnly'}
													value={item.quantidade}
													onChange={data => {
														
													}} />
											
												<LabelAndInput
													label='Observação' 
													placeholder='Informe a observação'
													cols='12 12 4 5'
													casas={2}
													readOnly={'readOnly'}
													value={item.observacao}
													onChange={data => {
													
													}} />

												<LabelAndInput
													label='Compartimentos' 
													placeholder='Informe'
													cols='12 12 4 1'
													readOnly={'readOnly'}
													value={compartimentos.map(compartimento => ({ value: compartimento.id, label: compartimento.valor })).filter(compartimento => (item.compartimentos || []).includes(compartimento.value)).map(compartimento => compartimento.label.replace('Compartimento ', '')).join(' | ')}
													onChange={data => {
													
													}} />											
												
												<Grid cols='12 12 1 1'>
													{this.props.listaEndereco.filter(endereco => endereco.id == item.id_endereco)[0] &&
													<a class='btn btn-app bg-primary' 
														style={{ marginTop: 8 }}
														onClick={() => {

															let endereco = this.props.listaEndereco.filter(endereco => endereco.id == item.id_endereco)[0];

															if (endereco && endereco.latitude && endereco.longitude) {
																window.open(`https://www.google.com/maps/place/${endereco.latitude},${endereco.longitude}`, '_blank', 'noreferrer');
															} else {
																window.alert('Localização não encontrada');
															}
														}}>
														<i class='fas fa-map-marker-alt'></i> Mapa
													</a>}
												</Grid>
													
											</Row>
										</Grid>
									</Row>
								)
							})}
							
						</ContentCardBody>
					)}
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='12 12 3 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									disabled={(this.props.formularioValues.id && this.props.formularioValues.id_status != 1 
										&& this.props.formularioValues.id_status != 2 
										&& !acessoLogistica && this.props.formularioValues.tracking_finalizado) || this.props.aguardando}
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 2 2'>
								<Button
									text='Imprimir Individual'
									type={'primary'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.imprimir(this.props.formularioValues, false)} />
							</Grid>
							<Grid cols='6 6 2 2'>
								<Button
									text='Imprimir Agrupado'
									type={'primary'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.imprimir(this.props.formularioValues, true)} />
							</Grid>
							<Grid cols='6 6 2 2'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>

					<ContentCardBody>
					{
						(unidadeSelecionada && itensMapa.length > 0) &&
						<Map 
							rota={this.state.rota}
							rotaCarregada={this.state.rotaCarregada}
							origem={{ ...unidadeSelecionada, nome: unidadeSelecionada.valor }}
							destino={{ ...unidadeSelecionada, nome: unidadeSelecionada.valor }}
							itens={itensMapa.map(item => ({
								id: item.id,
								nome: item.endereco ? item.endereco.valor : 'Sem endereço',
								latitude: item.endereco ? item.endereco.latitude : 0,
								longitude: item.endereco ? item.endereco.longitude : 0
							}))}
							todosClientesEnderecos={this.props.listaEndereco}
							pontos={this.props.listaEndereco.filter(endereco => !itensMapa.filter(mapa => mapa.endereco && mapa.id == endereco.id).length)
								.map(item => ({
								id: item.id,
								nome: `${item.razao_social} - ${item.id_petroshow}\n${item.valor}\n\nCPF/CNPJ: ${item.cnpj || item.cpf || ''}\nTelefone: ${item.telefone || ''}\nCelular: ${item.celular || ''}\nÚltimo Preço S10: ${item.ultimo_preco_s10 || ''}\nÚltimo Preço S500: ${item.ultimo_preco_s500 || ''}\nÚltima Compra: ${item.dias_ultima_compra == null ? '-' : item.dias_ultima_compra} ${item.dias_ultima_compra == null ? '' : (item.dias_ultima_compra == 1 ? 'dia' : 'dias')}\nLocalização: ${item.latitude || ''}, ${item.longitude || ''}`,
								latitude: item.latitude,
								longitude: item.longitude,
								id_petroshow: item.id_petroshow,
								whatsapp: item.whatsapp_venda,
								icone: `${item.dias_ultima_compra == null || item.dias_ultima_compra > 30 ? 'marker-vermelho' : (
									item.dias_ultima_compra > 7 ? 'marker-amarelo' : (
										'marker-verde'
									)
								)}${!codigoVendedor || codigoVendedor == item.codigo_vendedor ? '' : '-tag'}`
							}))}
							atualizarWhatsAppVenda={item => this.props.atualizarWhatsAppVenda(item)}
							onClickPonto={id => {
								
								let endereco = this.props.listaEndereco.filter(endereco => endereco.id == id)[0];
								
								if (endereco) {
									let lista = (this.props.formularioValues.itens || []).map(item => item);
			
									//1 - OLEO DIESEL B S10 ADITIVA / 3 - OLEO DIESEL B S500 ADITIVADO
									if (endereco.dias_ultima_compra == endereco.dias_ultima_compra_s10 && endereco.quantidade_s10 > 0) {

										let politicaSelecionada = this.props.listaPoliticaPreco.filter(politica => 
											politica.id_unidade == this.props.formularioValues.id_unidade
											&& politica.id_produto == 1)[0];

										lista.push({
											idAux: new Date().getTime(), 
											ativo: true, 
											ordem: lista.length + 1,
											id_cliente: endereco.id_cliente,
											id_endereco: endereco.id,
											id_produto: 1,
											quantidade: FormatUtils.formatarValorTela(endereco.quantidade_s10, 2),
											preco_unitario_bruto: politicaSelecionada ? FormatUtils.formatarValorTela(politicaSelecionada.preco_bruto, 4) : null,
											preco_unitario_base: politicaSelecionada ? FormatUtils.formatarValorTela(parseFloat(politicaSelecionada.preco) - parseFloat(politicaSelecionada.preco_frete), 4) : null,
											preco_unitario: politicaSelecionada ? FormatUtils.formatarValorTela(politicaSelecionada.preco, 4) : 0,
											preco_unitario_frete: politicaSelecionada ? FormatUtils.formatarValorTela(politicaSelecionada.preco_frete, 4) : null,
										}, true);
									}
									if (endereco.dias_ultima_compra == endereco.dias_ultima_compra_s500 && endereco.quantidade_s500 > 0) {

										let politicaSelecionada = this.props.listaPoliticaPreco.filter(politica => 
											politica.id_unidade == this.props.formularioValues.id_unidade
											&& politica.id_produto == 3)[0];

										lista.push({
											idAux: new Date().getTime(), 
											ativo: true, 
											ordem: lista.length + 1,
											id_cliente: endereco.id_cliente,
											id_endereco: endereco.id,
											id_produto: 3,
											quantidade: FormatUtils.formatarValorTela(endereco.quantidade_s500, 2),
											preco_unitario_bruto: politicaSelecionada ? FormatUtils.formatarValorTela(politicaSelecionada.preco_bruto, 4) : null,
											preco_unitario_base: politicaSelecionada ? FormatUtils.formatarValorTela(parseFloat(politicaSelecionada.preco) - parseFloat(politicaSelecionada.preco_frete), 4) : null,
											preco_unitario: politicaSelecionada ? FormatUtils.formatarValorTela(politicaSelecionada.preco, 4) : 0,
											preco_unitario_frete: politicaSelecionada ? FormatUtils.formatarValorTela(politicaSelecionada.preco_frete, 4) : null,
										});
									}
									if (endereco.quantidade_s10 <= 0 && endereco.quantidade_s500 <= 0) {
										lista.push({
											idAux: new Date().getTime(), 
											ativo: true, 
											ordem: lista.length + 1,
											id_cliente: endereco.id_cliente,
											id_endereco: endereco.id
										});
									}									
									
									this.props.initForm({
										...this.props.formularioValues,
										itens: lista
									});
								}
							}}
							setErro={erro => {
								this.setState({
									...this.state,
									rotaCarregada: null,
									rota: null,
									erroRota: true
								});
							}}
							setRota={rota => {
								this.setState({
									...this.state,
									rotaCarregada: rota.rotaCarregada,
									rota: {
										origem: rota ? rota.origem : null,
										destino: rota ? rota.destino : null,
										itens: rota ? rota.itens || [] : [],
										waypoints: rota ? rota.waypoints || [] : [],
										link_google_maps: rota ? rota.link_google_maps : null,
										distancia: rota ? rota.distancia : null,
										passos_localizacao: rota ? rota.passos_localizacao || [] : null,
										pontos: rota ? rota.pontos || [] : [],
										overview_polyline: rota ? rota.overview_polyline : null
									},
									erroRota: false
								});
							}} />}

						{this.state.erroRota &&
						<div class="alert alert-danger alert-dismissible">
							<h5><i class="icon fas fa-ban"></i> Não foi possível montar a rota!</h5>
							<h6>Verifique as Latitudes e longitudes</h6>

							{unidadeSelecionada && 
							<p><a href={`https://www.google.com/maps/place/${unidadeSelecionada.latitude},${unidadeSelecionada.longitude}`} target='_blank'>{unidadeSelecionada.valor}: {unidadeSelecionada.latitude}, {unidadeSelecionada.longitude}</a></p>}

							{itensMapa.map(item => (
								<p key={item.id}><a href={`https://www.google.com/maps/place/${item.endereco ? item.endereco.latitude : ''},${item.endereco ? item.endereco.longitude : ''}`} target='_blank'>{item.endereco ? item.endereco.valor : 'Sem endereço'}: {item.endereco ? item.endereco.latitude : ''}, {item.endereco ? item.endereco.longitude : ''}</a></p>
							))}
						</div>
						}
					</ContentCardBody>

				</Form>
			</ContentCard>
		)
    }

	modalVendaPerdidaItem() {

        return (
			<div class='modal fade show' id='modal-xl' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-md'>
					<div class='modal-content'>
						<div class='modal-header'>
							<h4 class='modal-title'>Informe se foi venda perdida</h4>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' 
								onClick={() => this.setState({ ...this.state, itemVendaPerdida: null })} >
								<span aria-hidden='true'>×</span>
							</button>
						</div>
						<div class='modal-body'>
							<Row>
								
								<LabelAndCheckbox
									label='Venda Perdida' 
									placeholder='Informe'
									cols='12 12 12 12'
									value={this.state.itemVendaPerdida.venda_perdida}
									onChange={data => {
										this.setState({
											...this.state,
											itemVendaPerdida: {
												...this.state.itemVendaPerdida,
												venda_perdida: !this.state.itemVendaPerdida.venda_perdida
											}
										});
									}} />

								<LabelAndInput
									label='Concorrente' 
									placeholder='Informe o concorrente'
									cols='12 12 12 12'
									value={this.state.itemVendaPerdida.concorrente}
									onChange={data => {
										this.setState({
											...this.state,
											itemVendaPerdida: {
												...this.state.itemVendaPerdida,
												concorrente: data.target.value
											}
										});
									}} />

								<LabelAndInputNumber
									label='Preço do Concorrente' 
									placeholder='Informe o preço'
									cols='12 12 12 12'
									casas={4}
									value={this.state.itemVendaPerdida.preco_concorrente}
									onChange={data => {
										this.setState({
											...this.state,
											itemVendaPerdida: {
												...this.state.itemVendaPerdida,
												preco_concorrente: data.target.value
											}
										});
									}} />

							</Row>
						</div>
						<div class='modal-footer justify-content-between'>
							<button type='button' class='btn btn-default' data-dismiss='modal' style={{ visibility: 'hidden' }}>Close</button>
							<button type='button' class='btn btn-primary'
								onClick={() => {
									this.props.initForm({
										...this.props.formularioValues,
										itens: this.props.formularioValues.itens.map(itemAux => {
											if (itemAux.id ? this.state.itemVendaPerdida.id == itemAux.id : this.state.itemVendaPerdida.idAux == itemAux.idAux) {
												return {
													...itemAux,
													ativo: false,
													venda_perdida: this.state.itemVendaPerdida.venda_perdida || false,
													concorrente: this.state.itemVendaPerdida.concorrente,
													preco_concorrente: FormatUtils.formatarValorBanco(this.state.itemVendaPerdida.preco_concorrente, 4)
												}
											} else {
												return itemAux;
											}
										})
									});

									this.setState({ ...this.state, itemVendaPerdida: null });
								}}>Salvar</button>
						</div>
					</div>
				</div>
			</div>
        );
    }

	modalVendaPerdida() {

        return (
			<div class='modal fade show' id='modal-xl' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-md'>
					<div class='modal-content'>
						<div class='modal-header'>
							<h4 class='modal-title'>Venda Perdida</h4>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' 
								onClick={() => this.setState({ ...this.state, modalVendaPerdida: false })} >
								<span aria-hidden='true'>×</span>
							</button>
						</div>
						<div class='modal-body'>
							<Row>
								
								<LabelAndInput
									label='Concorrente' 
									placeholder='Informe o concorrente'
									cols='12 12 12 12'
									value={this.props.formularioValues.concorrente}
									onChange={data => {
										this.props.initForm({
											...this.props.formularioValues,
											concorrente: data.target.value
										});
									}} />

								<LabelAndInputNumber
									label='Preço S10 do Concorrente' 
									placeholder='Informe o preço'
									cols='12 12 12 12'
									casas={4}
									value={this.props.formularioValues.preco_concorrente_s10}
									onChange={data => {
										this.props.initForm({
											...this.props.formularioValues,
											preco_concorrente_s10: data.target.value
										});
									}} />
									
								<LabelAndInputNumber
									label='Preço S500 do Concorrente' 
									placeholder='Informe o preço'
									cols='12 12 12 12'
									casas={4}
									value={this.props.formularioValues.preco_concorrente_s500}
									onChange={data => {
										this.props.initForm({
											...this.props.formularioValues,
											preco_concorrente_s500: data.target.value
										});
									}} />

							</Row>
						</div>
						<div class='modal-footer justify-content-between'>
							<button type='button' class='btn btn-default' data-dismiss='modal' style={{ visibility: 'hidden' }}>Close</button>
							<button type='button' class='btn btn-primary'
								onClick={() => {
									this.props.salvar({
										...this.props.formularioValues,
										id_status: 3, //Rejeitado
										venda_perdida: true,
										preco_concorrente_s10: FormatUtils.formatarValorBanco(this.props.formularioValues.preco_concorrente_s10, 4),
										preco_concorrente_s500: FormatUtils.formatarValorBanco(this.props.formularioValues.preco_concorrente_s500, 4)
									});
									this.setState({ ...this.state, modalVendaPerdida: false });
								}}>Salvar</button>
						</div>
					</div>
				</div>
			</div>
        );
    }

	modalEnderecoInformacoes() {
		
		if (!this.state.modalEnderecoInformacoes) {
			return null;
		}

		const enderecoCarregado = this.props.enderecoCarregado;

		return (
			<div class='modal fade show' id='modal-xl' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-xl'>
					<div class='modal-content'>
						<div class='modal-header'>
							<h4 class='modal-title'>Mais Informações</h4>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' 
								onClick={() => this.setState({ ...this.state, modalEnderecoInformacoes: null })} >
								<span aria-hidden='true'>×</span>
							</button>
						</div>
						{this.props.enderecoCarregado &&
						<div class='modal-body'
							style={{
								maxHeight: window.innerHeight - 350,
								overflowY: 'auto'
							}}>							
							<Row>

								<Grid cols='12 6 4 3'>
									<p><b>ID Petroshow:</b> {enderecoCarregado.id_petroshow_cliente}</p>
								</Grid>
								<Grid cols='12 6 4 3'>
									<p><b>{enderecoCarregado.cnpj ? 'CNPJ' : 'CPF'}:</b> {enderecoCarregado.cnpj ? FormatUtils.formatarCNPJ(enderecoCarregado.cnpj) : FormatUtils.formatarCPF(enderecoCarregado.cpf)}</p>
								</Grid>
								<Grid cols='12 6 4 3'>
									<p><b>Razão Social:</b> {enderecoCarregado.razao_social || ''}</p>
								</Grid>
								<Grid cols='12 6 4 3'>
									<p><b>Nome Fantasia:</b> {enderecoCarregado.nome_fantasia || ''}</p>
								</Grid>
								<Grid cols='12 6 4 3'>
									<p><b>Endereço:</b> {enderecoCarregado.endereco || ''}</p>
								</Grid>
								<Grid cols='12 6 4 3'>
									<p><b>Número:</b> {enderecoCarregado.numero || 'S/N'}</p>
								</Grid>
								<Grid cols='12 6 4 3'>
									<p><b>Complemento:</b> {enderecoCarregado.complemento || ''}</p>
								</Grid>
								<Grid cols='12 6 4 3'>
									<p><b>Bairro:</b> {enderecoCarregado.bairro || ''}</p>
								</Grid>
								<Grid cols='12 6 4 3'>
									<p><b>Cidade:</b> {enderecoCarregado.nome_cidade || ''}</p>
								</Grid>
								<Grid cols='12 6 4 3'>
									<p><b>CEP:</b> {FormatUtils.formatarCEP(enderecoCarregado.cep)}</p>
								</Grid>
								<Grid cols='12 6 4 3'>
									<p><b>Croqui:</b> {enderecoCarregado.croqui || ''}</p>
								</Grid>
								<Grid cols='12 6 4 3'>
									<p><b>Lat/Long:</b> {enderecoCarregado.latitude && enderecoCarregado.longitude ? `${enderecoCarregado.latitude},${enderecoCarregado.longitude}` : ''}</p>
								</Grid>

								<Grid cols='12 12 12 12'>
									<Table responsive>
										<THead>
											<Tr>
												<Th alignCenter>Data</Th>
												<Th alignCenter>Endereço</Th>
												<Th alignCenter>IE</Th>
												<Th alignCenter>Vendedor</Th>
												<Th alignCenter>Produto</Th>
												<Th alignCenter>Quantidade</Th>
												<Th alignCenter>Preço</Th>
												<Th alignCenter>Margem</Th>
												<Th alignCenter>Prazo</Th>
											</Tr>
										</THead>
										<TBody>
											{(enderecoCarregado.ultimas_vendas || []).map(item => {

												const preco = item.quantidade > 0 ? parseFloat(item.valor) / parseFloat(item.quantidade) : 0;
												const margem = item.quantidade > 0 ? (parseFloat(item.valor) - parseFloat(item.custo)) / parseFloat(item.quantidade) : 0;
												
												return (
													<Tr key={item.id}>
														<Td alignCenter>{DateFormat.formatarDataSqlParaTela(item.data_emissao)}</Td>
														<Td alignCenter>{item.endereco}</Td>
														<Td alignCenter>{item.inscricao_estadual || ''}</Td>
														<Td alignCenter>{item.nome_vendedor}</Td>
														<Td alignCenter>{item.produto}</Td>
														<Td alignCenter>{FormatUtils.formatarValorTela(item.quantidade, 0)}</Td>
														<Td alignCenter>{FormatUtils.formatarValorTela(preco, 4)}</Td>
														<Td alignCenter>{FormatUtils.formatarValorTela(margem, 4)}</Td>
														<Td alignCenter>{item.prazo}</Td>
													</Tr>
												);
											})}
										</TBody>
									</Table>
								</Grid>

							</Row>
						</div>}
						<div class='modal-footer justify-content-between'>
							<button type='button' class='btn btn-default' data-dismiss='modal' style={{ visibility: 'hidden' }}>Close</button>
						</div>
					</div>
				</div>
			</div>
		);
	}

	modalImprimir() {

		if (!this.state.modalImprimir) {
			return null;
		}

		return (
			<div class='modal fade show'
				id='modal-default'
				style={{ display: 'block', paddingRight: 15 }}
				aria-modal='true' 
				role='dialog' >
				<div class='modal-dialog'>
					<div class='modal-content'>
						<div class='modal-header'>
							<h5 class='modal-title' 
								style={{ width: '100%', textAlign: 'center' }}>Imprimir</h5>
						</div>
						<div class='modal-body'>
							<button
								type='button'
								class='btn btn-block btn-secondary btn-flat'
								onClick={() => {
									this.props.imprimirNovo(this.props.formularioValues, false, this.state.modalImprimir.id);
									this.setState({
										...this.state,
										modalImprimir: null
									});
								}}>Imprimir Individualmente</button>

							<button
								type='button'
								class='btn btn-block btn-secondary btn-flat'
								onClick={() => {
									this.props.imprimirNovo(this.props.formularioValues, true, this.state.modalImprimir.id);
									this.setState({
										...this.state,
										modalImprimir: null
									});
								}}>Agrupar Itens do Cliente</button>
						</div>
					</div>
				</div>
			</div>
		);
	}

}

PedidoForm = reduxForm({form: 'pedidoForm', destroyOnUnmount: false})(PedidoForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	formularioValues: getFormValues('pedidoForm')(state),
	aguardando: state.pedido.aguardando,
	registro: state.pedido.registro,
	listaDistribuidora: state.pedido.listaDistribuidora,
	listaPoliticaPreco: state.pedido.listaPoliticaPreco,
	listaUnidade: state.pedido.listaUnidade,
	listaMotorista: state.pedido.listaMotorista,
	listaVeiculo: state.pedido.listaVeiculo,
	listaCliente: state.pedido.listaCliente,
	listaEndereco: state.pedido.listaEndereco,
	listaProduto: state.pedido.listaProduto,
	listaCustoPrazo: state.pedido.listaCustoPrazo,
	listaStatus: state.pedido.listaStatus,
	enderecoCarregado: state.pedido.enderecoCarregado,
	listaPedidoTipo: state.pedido.listaPedidoTipo,
	listaPedidoFrete: state.pedido.listaPedidoFrete,
	listaPedidoCnpj: state.pedido.listaPedidoCnpj,
	listaPedidoPrazo: state.pedidoPrazo.listaSelect
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, salvar, imprimir, imprimirNovo, carregarEndereco, atualizarWhatsAppVenda
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(PedidoForm);
